"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSizer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getProperty = require("../getProperty");

var _createDetectElementResize = _interopRequireDefault(require("./createDetectElementResize"));

require("./AutoSizer.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AutoSizer = function AutoSizer(_ref) {
  var className = _ref.className,
      defaultWidth = _ref.defaultWidth,
      defaultHeight = _ref.defaultHeight,
      onResize = _ref.onResize,
      disableHeight = _ref.disableHeight,
      disableWidth = _ref.disableWidth,
      style = _ref.style,
      children = _ref.children;
  var nonce = null;

  var _useState = (0, _react.useState)(defaultWidth || 100),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultHeight || 0),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var autoSizerRef = (0, _react.useRef)(null);
  var parentNode = (0, _react.useRef)(null);
  var detectElementResize = (0, _react.useRef)(null);

  var handleResize = function handleResize() {
    if (parentNode.current) {
      // Guard against AutoSizer component being removed from the DOM immediately after being added.
      // This can result in invalid style values which can result in NaN values if we don't handle them.
      // See issue #150 for more context.
      var parentHeight = parentNode.current.offsetHeight || 0;
      var parentWidth = parentNode.current.offsetWidth || 0;

      var _style = window.getComputedStyle(parentNode.current) || {};

      var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
      var paddingRight = parseInt(_style.paddingRight, 10) || 0;
      var paddingTop = parseInt(_style.paddingTop, 10) || 0;
      var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
      var newHeight = parentHeight - paddingTop - paddingBottom;
      var newWidth = parentWidth - paddingLeft - paddingRight;

      if (!disableHeight && height !== newHeight || !disableWidth && width !== newWidth) {
        console.log("AutoSizer.handleResize update");
        setHeight(newHeight);
        setWidth(newWidth);

        if (typeof onResize === "function") {
          onResize({
            newHeight: newHeight,
            newWidth: newWidth
          });
        }
      }
    }
  };

  (0, _react.useEffect)(function () {
    var autosizer = autoSizerRef.current;
    var pn = (0, _getProperty.getProperty)("parentNode", autosizer, null);
    var dv = (0, _getProperty.getProperty)("parentNode.ownerDocument.defaultView", autosizer, null);
    console.log("AutoSizer.mount parentNode", pn);
    console.log("AutoSizer.mount dv", dv);

    if (autosizer && pn && dv && pn instanceof HTMLElement) {
      // delay access of parentnode until mount.
      // this handles edge-cases where the component has already been unmounted before its ref has been set,
      // as well as libraries like react-lite which have a slightly different lifecycle.
      parentNode.current = autosizer.parentNode; // defer requiring resize handler in order to support server-side rendering.
      // see issue #41

      detectElementResize.current = (0, _createDetectElementResize.default)(nonce, window);
      detectElementResize.current.addResizeListener(parentNode.current, function () {
        handleResize();
      });
      handleResize();
    }

    return function () {
      if (detectElementResize.current && parentNode.current) {
        detectElementResize.current.removeResizeListener(parentNode.current, handleResize);
      }
    };
  }, []); // Outer div should not force width/height since that may prevent containers from shrinking.
  // Inner component should overflow and use calculated width/height.
  // See issue #68 for more information.

  var outerStyle = {
    overflow: "visible"
  };
  var childParams = {};

  if (!disableHeight) {
    outerStyle.height = 0;
    childParams.height = height;
  }

  if (!disableWidth) {
    outerStyle.width = 0;
    childParams.width = width;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    ref: autoSizerRef,
    style: _objectSpread(_objectSpread({}, outerStyle), style)
  }, !!detectElementResize.current && children(childParams));
};

exports.AutoSizer = AutoSizer;